import { render, staticRenderFns } from "./story_search_button.vue?vue&type=template&id=6df45b16&lang=pug"
import script from "./story_search_button.vue?vue&type=script&lang=js"
export * from "./story_search_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports